import { Storage } from './storage';
export const storage = new Storage();
